var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2026 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @date 2026-10-16
 * @brief Management > 다운로드 자료관리
 *        (카탈로그·브로슈어 / 홍보 영상 / 도입 사례 자료 등록 · 공개 관리)
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useOutletContext } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
// recoil
import { alertState, confirmState } from "../../../recoil/assessmentState";
import { loadingBoxState } from "../../../recoil/menuState";
import { userInfoLoginState } from "../../../recoil/userState";
// utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
//component
import dayjs from "dayjs";
import EhpPagination from "../../common/pagination/EhpPagination";
import CmmConfirmPop from "../../common/popup/CmmConfirmPop";
// 노출 위치 (BE DownloadEntity.location)
const LOCATIONS = [
    { value: 1, name: "카탈로그·브로슈어" },
    { value: 2, name: "홍보 영상" },
    { value: 3, name: "도입 사례" },
];
const LINK_TYPE_LINK = "link";
const LINK_TYPE_FILE = "file";
const MAX_FILE_SIZE = 524288000; // 500MB
function locationName(location) {
    const found = LOCATIONS.find((item) => item.value == location);
    return found ? found.name : "-";
}
function openUrl(url) {
    if (CUTIL.isnull(url))
        return;
    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    window.open(href, "_blank", "noopener");
}
function reloadKey() {
    return Math.floor(Math.random() * 8999999) + 1000000;
}
export default function DownloadMain() {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [downloadList, setDownloadList] = useState([]);
    const [stateName, setStateName] = useState("전체");
    const [state, setState] = useState("");
    const [locName, setLocName] = useState("전체");
    const [loc, setLoc] = useState("");
    const [reload, setReload] = useState(0);
    const [downloadId, setDownloadId] = useState(0);
    const [delDownloadId, setDelDownloadId] = useState(0);
    // props
    const { handleOpenPop } = useOutletContext();
    useEffect(() => {
        handleOpenPop("pop-cmm", _jsx(AddDownload, { setReload: setReload, downloadId: downloadId, setDownloadId: setDownloadId }));
        handleOpenPop("pop-cmm2", _jsx(DeleteDownload, { setReload: setReload, downloadId: delDownloadId, setDelDownloadId: setDelDownloadId }));
    }, [downloadId, delDownloadId]);
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    const [sortData, setSortData] = useState({
        sortField: "createdTime",
        sort: "desc",
    });
    let page = `page=${pageInfo.number}&size=${pageInfo.size}&sort=${sortData.sortField},${sortData.sort}`;
    let param = ``;
    if (state != "") {
        param = param + `&isPublic=${state}`;
    }
    if (loc != "") {
        param = param + `&location=${loc}`;
    }
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/downloads?${page}${param}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: page + param + reload,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                let trs = document.querySelector("#listBody").children;
                Array.prototype.forEach.call(trs, (element) => element.classList.remove("selected"));
                setDownloadList(data.body);
                setPageInfo(data.data.page);
            }
        }
    }, [data]);
    function onClickSelect(e) {
        let select = e.currentTarget;
        if (select.classList.contains("active")) {
            select.classList.remove("active");
        }
        else {
            select.classList.add("active");
        }
    }
    function selectTr(e) {
        let target = e.currentTarget;
        if (target.classList.contains("selected")) {
            target.classList.remove("selected");
        }
        else {
            let trs = document.querySelector("#listBody").children;
            Array.prototype.forEach.call(trs, (element) => element.classList.remove("selected"));
            target.classList.add("selected");
        }
    }
    function onSelectBox(e, type) {
        let selType = e.currentTarget.dataset.value;
        let li = e.currentTarget;
        let lis = li.parentNode.childNodes;
        lis.forEach((item) => (item.className = "option"));
        li.className = "option active";
        if (type == "isPublic") {
            setStateName(e.currentTarget.innerText);
            setState(selType);
        }
        else {
            setLocName(e.currentTarget.innerText);
            setLoc(selType);
        }
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: 0 }));
    }
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function openAddDownload(e, id) {
        if (id != null)
            setDownloadId(id);
        CUTIL.jsopen_Popup(e);
    }
    function openDeleteDownload(e, id) {
        setDelDownloadId(id);
        CUTIL.jsopen_Popup(e);
    }
    function onClickSort(e) {
        var actTag = e.target.tagName == "TH" ? e.target : e.currentTarget;
        var selSortField = actTag.getAttribute("data-value");
        var selSort = sortData.sort === "asc" ? "DESC" : "asc";
        if (selSortField !== sortData.sortField) {
            // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: 0 }));
        setSortData({
            sortField: selSortField,
            sort: selSort,
        });
    }
    function onClickLink(e, item) {
        e.stopPropagation();
        if (item.linkType == LINK_TYPE_FILE) {
            if (!CUTIL.isnull(item.fileUrl))
                window.location.href = item.fileUrl;
        }
        else {
            openUrl(item.link);
        }
    }
    return (_jsx("div", Object.assign({ className: "box-wrap" }, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "\uB2E4\uC6B4\uB85C\uB4DC \uC790\uB8CC\uAD00\uB9AC" })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-24" }, { children: _jsx("strong", { children: "\uC0C1\uD0DC" }) })), _jsxs("div", Object.assign({ className: "select w158", onClick: (e) => onClickSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: stateName })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "isPublic"), "data-value": "" }, { children: "\uC804\uCCB4" })), _jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "isPublic"), "data-value": "true" }, { children: "\uACF5\uAC1C" })), _jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "isPublic"), "data-value": "false" }, { children: "\uBE44\uACF5\uAC1C" }))] })] })), _jsx("span", Object.assign({ className: "mr-16 ml-48" }, { children: _jsx("strong", { children: "\uB178\uCD9C \uC704\uCE58" }) })), _jsxs("div", Object.assign({ className: "select w158", onClick: (e) => onClickSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: locName })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "location"), "data-value": "" }, { children: "\uC804\uCCB4" })), LOCATIONS.map((item) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e, "location"), "data-value": item.value }, { children: item.name }), `loc_${item.value}`)))] })] }))] })) })) })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-cmm", onClick: (e) => openAddDownload(e, null) }, { children: _jsx("span", { children: "\uC790\uB8CC \uCD94\uAC00" }) })) }))] })), _jsxs("div", Object.assign({ className: "tbl-list tbl-select" }, { children: [_jsxs("table", Object.assign({ summary: "No., \uB178\uCD9C \uC704\uCE58, \uC0C1\uD0DC, \uC81C\uBAA9, \uAD00\uB828 \uB9C1\uD06C \u00B7 \uCCA8\uBD80\uD30C\uC77C \uB2E4\uC6B4\uB85C\uB4DC \uB9C1\uD06C, \uB4F1\uB85D\uC77C\uC790, \uC218\uC815, \uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uB2E4\uC6B4\uB85C\uB4DC \uC790\uB8CC\uAD00\uB9AC \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uB2E4\uC6B4\uB85C\uB4DC \uC790\uB8CC\uAD00\uB9AC \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "22%" } }), _jsx("col", { style: { width: "32%" } }), _jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "6%" } }), _jsx("col", { style: { width: "6%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uB178\uCD9C \uC704\uCE58" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "isPublic" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "isPublic" }, { children: _jsx("span", { children: "\uC0C1\uD0DC" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC81C\uBAA9" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uAD00\uB828 \uB9C1\uD06C \u00B7 \uCCA8\uBD80\uD30C\uC77C \uB2E4\uC6B4\uB85C\uB4DC \uB9C1\uD06C" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "createdTime" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "createdTime" }, { children: _jsx("span", { children: "\uB4F1\uB85D \uC77C\uC790" }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: "\uC218\uC815" }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: "\uC0AD\uC81C" }) }))] }) }), _jsx("tbody", Object.assign({ id: "listBody" }, { children: downloadList &&
                                                downloadList.map((item, index) => {
                                                    const isFile = item.linkType == LINK_TYPE_FILE;
                                                    const linkText = isFile ? item.fileName : item.link;
                                                    return (_jsxs("tr", Object.assign({ onClick: (e) => selectTr(e) }, { children: [_jsx("td", { children: pageInfo.totalElements - pageInfo.number * pageInfo.size - index }), _jsx("td", { children: locationName(item.location) }), _jsx("td", { children: _jsx("span", Object.assign({ className: item.isPublic ? "txt-blue" : "txt-gray" }, { children: item.isPublic ? "공개" : "비공개" })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis w90p" }, { children: item.title })) }), _jsx("td", { children: CUTIL.isnull(linkText) ? (_jsx("p", Object.assign({ className: "ellipsis w90p txt-gray" }, { children: isFile ? "[첨부파일] 미등록" : "-" }))) : (_jsx("p", Object.assign({ className: "ellipsis w90p", title: linkText }, { children: _jsxs("a", Object.assign({ href: "#", className: "txt-blue", onClick: (e) => {
                                                                            e.preventDefault();
                                                                            onClickLink(e, item);
                                                                        } }, { children: [isFile ? "[첨부파일] " : "[관련 링크] ", linkText] })) }))) }), _jsx("td", { children: dayjs(item.createdTime).format("YYYY-MM-DD") }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g", "data-pop": "pop-cmm", onClick: (e) => openAddDownload(e, item.downloadId) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-cmm2", onClick: (e) => openDeleteDownload(e, item.downloadId) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }), `download_${index}`));
                                                }) }))] })), downloadList && downloadList.length == 0 && (_jsx("p", Object.assign({ className: "txt-center txt-gray pt-24 pb-24" }, { children: "\uC870\uD68C\uB41C \uC790\uB8CC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." })))] })), _jsx(EhpPagination, { componentName: "DOWNLOAD", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))] })) })));
}
function AddDownload(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [confirm, setConfirm] = useRecoilState(confirmState);
    const loadingBox = useSetRecoilState(loadingBoxState);
    const [location, setLocation] = useState(LOCATIONS[0].value); // 기본값 카탈로그·브로슈어
    const [title, setTitle] = useState("");
    const [linkType, setLinkType] = useState(LINK_TYPE_LINK);
    const [link, setLink] = useState("");
    const [isPublic, setIsPublic] = useState(true);
    const [savedFileName, setSavedFileName] = useState(""); // 수정 시 이미 등록된 파일
    const [savedFileUrl, setSavedFileUrl] = useState("");
    const [newFile, setNewFile] = useState(null);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [disabledBtn, setDisabledBtn] = useState(false);
    let downloadId = props.downloadId;
    const isEdit = downloadId != 0;
    const popTitle = isEdit ? "자료 수정" : "자료 추가";
    useEffect(() => {
        if (downloadId != 0) {
            callDetailDownload(downloadId);
        }
    }, [downloadId]);
    function closePop() {
        CUTIL.jsclose_Popup("pop-cmm");
        props.setDownloadId(0);
        setDisabledBtn(false);
        setInit();
    }
    function setInit() {
        setLocation(LOCATIONS[0].value);
        setTitle("");
        setLinkType(LINK_TYPE_LINK);
        setLink("");
        setIsPublic(true);
        setSavedFileName("");
        setSavedFileUrl("");
        setNewFile(null);
        setFileInputKey(fileInputKey + 1);
    }
    function showAlert(msg, callBack = null) {
        setAlert(Object.assign(Object.assign({}, alert), { header: popTitle, type: CONST.TYPE_NONE, divTag: msg, callBack: (e) => {
                setDisabledBtn(false);
                if (callBack)
                    callBack(e);
            } }));
        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
    }
    function onChangeFile(e) {
        let file = e.target.files && e.target.files[0];
        if (!file)
            return;
        if (file.size >= MAX_FILE_SIZE) {
            showAlert("파일은 최대 500MB까지 첨부가능합니다.");
            setFileInputKey(fileInputKey + 1);
            return;
        }
        setNewFile(file);
    }
    function saveDownload() {
        if (location == 0) {
            setDisabledBtn(true);
            showAlert("노출 위치를 선택해주세요.");
            return;
        }
        else if (title.trim() == "") {
            setDisabledBtn(true);
            showAlert("제목을 입력해주세요.");
            return;
        }
        else if (linkType == LINK_TYPE_LINK && link.trim() == "") {
            setDisabledBtn(true);
            showAlert("관련 링크를 입력해주세요.");
            return;
        }
        else if (linkType == LINK_TYPE_FILE && newFile == null && savedFileName == "") {
            setDisabledBtn(true);
            showAlert("첨부파일을 선택해주세요.");
            return;
        }
        setConfirm(Object.assign(Object.assign({}, confirm), { header: popTitle, content: isEdit ? "자료를 수정하시겠습니까?" : "자료를 추가하시겠습니까?", leftBtnName: "취소", rightBtnName: "확인", leftBtnCallBack: (e) => {
                setDisabledBtn(false);
            }, rightBtnCallBack: (e) => __awaiter(this, void 0, void 0, function* () {
                loadingBox(true);
                let res = yield HTTPUTIL.PromiseHttp({
                    httpMethod: isEdit ? "PUT" : "POST",
                    appPath: isEdit ? `/download/${downloadId}` : `/download`,
                    appQuery: {
                        location: location,
                        isPublic: isPublic,
                        title: title,
                        linkType: linkType,
                        link: linkType == LINK_TYPE_LINK ? link : null,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (res && res.codeNum == CONST.API_200) {
                    if (linkType == LINK_TYPE_FILE && newFile != null) {
                        fileUpload(res.body.downloadId);
                    }
                    else {
                        complete();
                    }
                }
                else {
                    loadingBox(false);
                    showAlert(isEdit ? "수정 실패하였습니다." : "추가 실패하였습니다.");
                }
            }) }));
        setDisabledBtn(true);
        CUTIL.jsopen_AlertPopup(CONST.POP_CMM_CONFIRM);
    }
    function fileUpload(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("file", newFile);
            let res = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/download/${id}/file`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
                onUploadProgress: () => { },
            });
            if (res && res.codeNum == CONST.API_200) {
                complete();
            }
            else {
                // 자료는 저장되었으므로 목록은 갱신하고, 파일은 수정 화면에서 다시 올리도록 안내한다.
                loadingBox(false);
                showAlert("자료는 저장되었으나 파일 업로드에 실패하였습니다. 수정에서 파일을 다시 등록해주세요.", () => {
                    closePop();
                    props.setReload(reloadKey());
                });
            }
        });
    }
    function complete() {
        loadingBox(false);
        showAlert(isEdit ? "자료 수정이 완료되었습니다." : "자료 등록이 완료되었습니다.", () => {
            closePop();
            props.setReload(reloadKey());
        });
    }
    function callDetailDownload(id) {
        return __awaiter(this, void 0, void 0, function* () {
            loadingBox(true);
            let data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/download/${id}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            loadingBox(false);
            if (data && data.codeNum == CONST.API_200) {
                let item = data.body;
                setLocation(item.location);
                setTitle(item.title == null ? "" : item.title);
                setLinkType(item.linkType == LINK_TYPE_FILE ? LINK_TYPE_FILE : LINK_TYPE_LINK);
                setLink(item.link == null ? "" : item.link);
                setIsPublic(item.isPublic == true);
                setSavedFileName(item.fileName == null ? "" : item.fileName);
                setSavedFileUrl(item.fileUrl == null ? "" : item.fileUrl);
            }
            else {
                showAlert("상세 불러오기 오류");
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "pop-cmm", className: "popup-layer js-layer hidden popup-type2 w964" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: popTitle }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePop, disabled: disabledBtn }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "popup__body", style: { maxHeight: "none", overflowY: "visible", paddingBottom: "26px" } }, { children: [_jsxs("ul", Object.assign({ className: "form__input mt-5" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uB178\uCD9C \uC704\uCE58" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("div", Object.assign({ className: "radioBox" }, { children: LOCATIONS.map((item) => (_jsxs("label", Object.assign({ htmlFor: `dl_location_${item.value}` }, { children: [_jsx("input", { type: "radio", id: `dl_location_${item.value}`, name: "dl_location", checked: location == item.value, onChange: () => setLocation(item.value) }), item.name] }), `dl_location_${item.value}`))) })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC81C\uBAA9" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", value: title, maxLength: 255, placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", onChange: (e) => setTitle(e.target.value) }) }))] })] })), _jsxs("ul", Object.assign({ className: "form__input brd-top-1 pt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC790\uB8CC \uC720\uD615" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "dl_linkType_link" }, { children: [_jsx("input", { type: "radio", id: "dl_linkType_link", name: "dl_linkType", checked: linkType == LINK_TYPE_LINK, onChange: () => setLinkType(LINK_TYPE_LINK) }), "\uAD00\uB828 \uB9C1\uD06C"] })), _jsxs("label", Object.assign({ htmlFor: "dl_linkType_file" }, { children: [_jsx("input", { type: "radio", id: "dl_linkType_file", name: "dl_linkType", checked: linkType == LINK_TYPE_FILE, onChange: () => setLinkType(LINK_TYPE_FILE) }), "\uCCA8\uBD80\uD30C\uC77C"] }))] })) }))] }), linkType == LINK_TYPE_LINK ? (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uAD00\uB828 \uB9C1\uD06C" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", value: link, maxLength: 1024, placeholder: "ex)https://www.youtube.com/watch?v=...", className: "txt-blue", onChange: (e) => setLink(e.target.value) }), _jsx("p", Object.assign({ className: "txt-info" }, { children: "\uD64D\uBCF4 \uC601\uC0C1 \uB4F1 \uC678\uBD80 \uD398\uC774\uC9C0 \uC8FC\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694." }))] }))] })) : (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uCCA8\uBD80\uD30C\uC77C" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", placeholder: "\uD30C\uC77C\uC744 \uCCA8\uBD80\uD558\uC138\uC694", value: newFile ? newFile.name : "", readOnly: true }), _jsx("label", Object.assign({ htmlFor: "dl_file" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "dl_file", onChange: (e) => onChangeFile(e) }, fileInputKey)] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: "500MB \uC774\uD558\uC758 \uD30C\uC77C 1\uAC1C\uB97C \uC5C5\uB85C\uB4DC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC0C8 \uD30C\uC77C\uC744 \uC62C\uB9AC\uBA74 \uAE30\uC874 \uD30C\uC77C\uC740 \uAD50\uCCB4\uB429\uB2C8\uB2E4." })), savedFileName != "" && (_jsx("ul", Object.assign({ className: "filelist mt-12" }, { children: _jsx("li", { children: _jsx("span", Object.assign({ onClick: () => (window.location.href = savedFileUrl), style: { cursor: "pointer", textDecoration: newFile ? "line-through" : "none" } }, { children: savedFileName })) }) })))] }))] }))] })), _jsx("ul", Object.assign({ className: "form__input brd-top-1 pt-24" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC0C1\uD0DC \uC124\uC815" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "dl_isPublic_true" }, { children: [_jsx("input", { type: "radio", id: "dl_isPublic_true", name: "dl_isPublic", checked: isPublic, onChange: () => setIsPublic(true) }), "\uACF5\uAC1C"] })), _jsxs("label", Object.assign({ htmlFor: "dl_isPublic_false" }, { children: [_jsx("input", { type: "radio", id: "dl_isPublic_false", name: "dl_isPublic", checked: !isPublic, onChange: () => setIsPublic(false) }), "\uBE44\uACF5\uAC1C"] }))] })) }))] }) }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", disabled: disabledBtn, className: "bg-gray js-close", onClick: closePop }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", disabled: disabledBtn, onClick: saveDownload }, { children: _jsx("span", { children: "\uC800\uC7A5" }) }))] }))] })), _jsx(CmmConfirmPop, {})] }));
}
function DeleteDownload(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    function closePop() {
        props.setDelDownloadId(0);
        CUTIL.jsclose_Popup("pop-cmm2");
    }
    function deleteDownload() {
        return __awaiter(this, void 0, void 0, function* () {
            let resDelete = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/download/${props.downloadId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (resDelete) {
                if (resDelete.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { header: "다운로드 자료", type: CONST.TYPE_NONE, divTag: "삭제가 완료되었습니다.", callBack: (e) => {
                            closePop();
                            props.setReload(reloadKey());
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-cmm2", className: "popup-layer js-layer hidden popup-basic" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "\uC0AD\uC81C" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePop }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: "\uB4F1\uB85D\uB41C \uC790\uB8CC\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: closePop }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: deleteDownload }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] })) }));
}
